@import '../../../../../../../constants/spacing.module.less';

.modal-description {
  margin: @space-16;
}

.table-container {
  margin: 0 @space-16 @space-16;
  border: 1px solid var(--grey-300);
  border-radius: @space-4;
  overflow: hidden;
}

.errors-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

.table-header {
  text-align: left;
  padding: @space-8 @space-16;
  background-color: var(--grey-100);
}

.table-row {
  border-bottom: 1px solid var(--table--border-color--2);

  &:last-of-type {
    border-bottom: none;
  }
}

.table-cell {
  padding: @space-8 @space-16;
  overflow-wrap: anywhere;
}

.missing-quantity {
  color: var(--red-500);
  font-weight: 600;
}

.product-sku {
  color: var(--grey-500);
}

.modal-footer-buttons {
  justify-content: flex-end;
}
